import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { LuInfo } from 'react-icons/lu';

import { setStagingFooterClearanceCssVar } from './stagingFooterPadding';
import { VITE_MODE } from '~/config';

export default function StagingFooter() {
    const { t } = useTranslation();
    const isStaging = VITE_MODE === 'staging';

    useEffect(() => {
        setStagingFooterClearanceCssVar(isStaging);
        return () => {
            setStagingFooterClearanceCssVar(false);
        };
    }, [isStaging]);

    if (!isStaging) {
        return null;
    }

    const label = t('STAGING_FOOTER.LABEL');

    return (
        <footer
            role="status"
            aria-label={label}
            className="fixed bottom-0 left-0 right-0 z-[9990] flex min-h-8 items-center justify-center bg-orange px-8 pb-[env(safe-area-inset-bottom,0px)]"
        >
            <div className="flex items-center justify-center gap-2.5 rounded py-1 px-6">
                <LuInfo className="size-4 text-white" aria-hidden />
                <span className="text-sm text-white select-none">{label}</span>
            </div>
        </footer>
    );
}
